import { createContext, React, useState } from 'react';
import { Chatbot } from '../components/chatbot/Chatbot';

export const ChatBotContext = createContext();

export const ChatBotProvider = ({ children }) => {
    const [userPrompt, setUserPrompt] = useState('');
    const [chatPrompt, setChatPrompt] = useState('');
    const [show, setShow] = useState(false);

    const updateChatBotPrompt = (prompt) => {
        setChatPrompt(prompt);
        setUserPrompt('Please explain this graph for me!');
        setShow(true);
    };

    return (
        <ChatBotContext.Provider
            value={{
                show,
                setShow,
                userPrompt,
                setUserPrompt,
                chatPrompt,
                setChatPrompt,
                updateChatBotPrompt,
            }}
        >
            {children}
            <Chatbot/>
        </ChatBotContext.Provider>
    );
};
